{
  "applications": {
    "actions": {
      "journal": "Journal",
      "notification_filters": "Benachrichtigungsfilter",
      "refresh_applications": "Anwendungen aktualisieren",
      "restart": "Neu starten",
      "shutdown": "Herunterfahren",
      "switch_to_grouping_by_application": "Aggregiere Instanzen zu Applikationen (gleiche Namen)",
      "switch_to_grouping_by_group": "Gruppiere Instanzen anhand des Gruppennamens",
      "unregister": "Deregistrieren"
    },
    "last_update": "Letzte Aktualisierung",
    "all_up": "Alle verfügbar",
    "all_down": "Alle Instanzen sind ausgefallen",
    "all_unknown": "Alle Instanzen haben unbekannten Status",
    "some_unknown": "Einige Instanzen haben unbekannten Status",
    "some_down": "Einige Instanzen sind ausgefallen",
    "applications": "Anwendungen",
    "fetching_notification_filters_failed": "Der Abruf der Benachrichtigungseinstellungen ist fehlgeschlagen.",
    "notification_filter": {
      "none": "Keine Benachrichtigungseinstellungen gesetzt.",
      "removed": "Benachrichtigungseinstellungen wurden geändert."
    },
    "instances": "Instanzen",
    "loading_applications": "Anwendungen werden geladen...",
    "no_applications_registered": "Keine Anwendungen registriert.",
    "notifications_suppressed_for": "Benachrichtigungen für <code>{name}</code> werden unterdrückt für",
    "restricted": "eingeschränkt",
    "server_connection_failed": "Verbindung zum Server fehlgeschlagen.",
    "suppress_notifications_on": "Benachrichtungen für <code>{name}</code> für",
    "status": "Status",
    "label": "Anwendungen",
    "shutdown": "Möchten Sie die Anwendung <code>{name}</code> herunterfahren?",
    "refreshed": "Anwendungen wurden aktualisiert.",
    "restart": "Möchten Sie Anwendung <code>{name}</code> neu starten?",
    "restarted": "Die Anwendung wurde neu gestartet.",
    "unregister": "Möchten Sie die Anwendung <code>{name}</code> deregistrieren?",
    "unregister_successful": "Die Anwendung {name} wurde erfolgreich deregistriert.",
    "unregister_failed": "Deregistration der Anwendung <code>{name}</code> fehlgeschlagen ({error})."
  },
  "instances": {
    "shutdown": "Möchten Sie die Instanz <code>{name}</code> herunterfahren?",
    "open_details": "Instanzdetails öffnen",
    "restart": "Möchten Sie die Instanz <code>{name}</code> neu starten?",
    "restarted": "Die Instanz {name} wurde neu gestartet.",
    "unregister": "Möchten Sie die Instanz <code>{name}</code> deregistrieren?",
    "unregister_successful": "Die Instanz {name} wurde erfolgreich deregistriert.",
    "unregister_failed": "Deregistration der Instanz <code>{name}</code> fehlgeschlagen ({error})."
  },
  "notification_filter_center": {
    "description": "Benachrichtigungen für folgende Applikationen / Instanzen werden unterdrückt."
  },
  "filter": {
    "no_results": "Keine Ergebnisse für den eingestellten Filter."
  }
}
